import React, { useState } from "react";
import ReactJson from "react-json-view";

const Codetext = ({ data }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    setCopied(true);

    // Reset after 1.5 seconds
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div
        style={{
          position: "relative",
          zIndex: "0",
          padding: "10px",
          background: "#002b36",
          borderRadius: "8px",
        }}
      >
        <button
          onClick={handleCopy}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#5e7660",
            color: "white",
            border: "none",
            padding: "5px 10px",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "11px",
            zIndex: "999",
            margin: "10px",
          }}
        >
          {copied ? "Copied! ✅" : "Copy 📋"}
        </button>
        <ReactJson
          src={data}
          name={false}
          theme="ocean"
          collapsed={false}
          enableClipboard={false}
          displayDataTypes={false}
        />
      </div>
    </>
  );
};

export default Codetext;
